import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophoneOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19 11C19 11.7099 18.8943 12.3951 18.6979 13.0408M12 18C8.13401 18 5 14.866 5 11M12 18V21M12 18C13.6784 18 15.2188 17.4093 16.4248 16.4244M9.71413 4.05703C10.2644 3.41027 11.0843 3 12 3C13.6569 3 15 4.34315 15 6V9.3429M9 8.99975V11C9 12.6569 10.3431 14 12 14C12.5722 14 13.107 13.8398 13.562 13.5618",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 4L20 20",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgMicrophoneOff;
